import { optimizationTargetOptions } from "../analyseData/advancedSettings.config";

import { formattedCurrencyValue } from "../../utils/currencyUtils";

const formattedCurrency = (value, currency) => {
  const formatted = formattedCurrencyValue(value, currency);
  return value < 0 ? `- ${formatted}` : formatted;
};

const formattedWaterProductionIncrease = (value, percentValue, volumeUnit) => {
  const unit = volumeUnit === "m3" ? "m³" : volumeUnit;
  const formattedValue = parseFloat(value ?? 0).toFixed(2);
  const formattedPercent = parseFloat(percentValue ?? 0).toFixed(2);
  return `${formattedValue} ${unit} (${formattedPercent}%)`;
};

const formattedEnergyCostSavings = (value, percentValue, currency) => {
  const formattedPercent = parseFloat(percentValue ?? 0).toFixed(2);
  const formattedValue = formattedCurrency(value, currency);
  return `${formattedValue} (${formattedPercent}%)`;
};

export const getBenefitsInfo = (
  predictionData,
  optimizationTarget,
  currency,
  volumeUnit,
  annual = false,
) => {
  if (!predictionData || !optimizationTarget) {
    return { show: false };
  }

  const {
    total_financial_benefits,
    increased_production,
    increased_production_percent,
    energy_saving_dollars,
    energy_saving_percent,
    annual_total_financial_benefits,
    annual_increased_production,
    annual_increased_production_percent,
    annual_energy_saving_dollars,
    annual_energy_saving_percent,
  } = predictionData;

  let show = false;
  let benefitsLabel = annual ? "totalAnnualBenefits" : "totalFinancialBenefits";
  let benefitsValue = annual
    ? formattedCurrency(annual_total_financial_benefits, currency)
    : formattedCurrency(total_financial_benefits, currency);
  let showPopover = false;

  if (
    optimizationTarget === optimizationTargetOptions.maximizeFinancialBenefits
  ) {
    show = annual
      ? annual_total_financial_benefits > 0
      : total_financial_benefits > 0;
    showPopover = true;
  } else if (optimizationTarget === optimizationTargetOptions.maximizeProduct) {
    show = annual ? annual_increased_production > 0 : increased_production > 0;
    benefitsLabel = annual
      ? "annualWaterProductionIncrease"
      : "waterProductionIncrease";
    benefitsValue = annual
      ? formattedWaterProductionIncrease(
          annual_increased_production,
          annual_increased_production_percent,
          volumeUnit,
        )
      : formattedWaterProductionIncrease(
          increased_production,
          increased_production_percent,
          volumeUnit,
        );
  } else if (
    optimizationTarget === optimizationTargetOptions.minimizeEnergyCost
  ) {
    show = annual
      ? annual_energy_saving_dollars > 0
      : energy_saving_dollars > 0;
    benefitsLabel = annual ? "annualEnergySaving" : "energySaving";
    benefitsValue = annual
      ? formattedEnergyCostSavings(
          annual_energy_saving_dollars,
          annual_energy_saving_percent,
          currency,
        )
      : formattedEnergyCostSavings(
          energy_saving_dollars,
          energy_saving_percent,
          currency,
        );
  }

  const data = { benefitsLabel, benefitsValue };

  return { show, showPopover, data };
};

// Helper function to get translated optimization target key
export const getOptimizationTargetKey = (optimizationTarget) => {
  if (!optimizationTarget) return "";
  let key = optimizationTarget.split(" ");
  key = key[0].toLowerCase() + key.slice(1).join("");
  return key;
};
